import { render, staticRenderFns } from "./deepseek.vue?vue&type=template&id=4b6c6b41&scoped=true"
import script from "./deepseek.vue?vue&type=script&lang=js"
export * from "./deepseek.vue?vue&type=script&lang=js"
import style0 from "./deepseek.vue?vue&type=style&index=0&id=4b6c6b41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6c6b41",
  null
  
)

export default component.exports